import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiDialog(_theme: Theme): MuiThemeComponentOverride<"MuiDialog"> {
  return {
    MuiDialog: {
      styleOverrides: {
        paperWidthSm: {
          minWidth: "375px",
        },
      },
    },
  };
}
